import { useRef, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import ReactQuill from 'react-quill-new';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { emailReminder } from '../store/Slices/WorkOrderSlice';
import '../styles/Input.css';
import { hasPermission, modules } from '../utils/helper';
import { errorNotify, successNotify } from '../utils/toast';

const Input = ({ label, placeholder, type, name, value, onChange, onBlur,
  error, touched, disabled = false, className = '', showExtraText = false, extraText, quill = false, setFieldValue, showIcon = null }) => {

  const { id } = useParams();
  const dispatch = useDispatch();

  const { emailReminderLoading } = useSelector((state) => state.workOrder);

  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);

  const canFinanceApproval = hasPermission("work-orders", "finance-approval");
  const canOperationalApproval = hasPermission("work-orders", "operations-approval");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const inputType = type === 'password' && showPassword ? 'text' : type;

  const handleWrapperMouseDown = (e) => {
    if ((type === 'date' || type === 'datetime-local') && inputRef.current && !disabled) {
      e.preventDefault();
      inputRef.current.focus();
      // Try to open native picker if supported
      if (typeof inputRef.current.showPicker === 'function') {
        inputRef.current.showPicker();
      }
    }
  };

  const emailReminderHandler = async (name) => {
    try {

      if (name === "finance_status" && !canFinanceApproval) {
        throw new Error("You do not have permission for finance approval.");
      }

      // Check for operational approval condition
      if (name === "operations_status" && !canOperationalApproval) {
        throw new Error("You do not have permission for operational approval.");
      }

      let data = {
        work_order_id: parseInt(id),
        reminder_type: name === "finance_status" ? "finance-approval" : "operations-approval",
      }
      await dispatch(emailReminder(data)).unwrap();
      successNotify("Email reminder sent successfully");
    }
    catch (err) {
      errorNotify(err);
    }
  }

  return (
    <div className={`input_wrapper ${className}`}>
      <div
        className={`input_container ${disabled ? 'disabled' : ''}`}
        style={{ position: 'relative' }}
        onMouseDown={handleWrapperMouseDown}
      >
        <label>{label}</label>
        {
          quill ? (
            <div style={{ marginTop: '5px' }}>
              <ReactQuill
                placeholder={placeholder}
                modules={modules}
                theme="snow"
                value={value || ''}
                onChange={content => {
                  if (typeof setFieldValue === 'function') {
                    setFieldValue(name, content);
                  } else if (typeof onChange === 'function') {
                    onChange(content);
                  }
                }}
                name={name}
                className='react_quill_input quill-small-font' // add custom class
              />
            </div>
          ) :
            <input
              ref={inputRef}
              type={inputType}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              disabled={disabled}
              style={{
                cursor: inputType === 'date' || inputType === 'datetime-local' ? 'pointer' : 'text',
                textTransform: name === "finance_status" || name === "operation_status" ? 'capitalize' : 'none'
              }}
            />
        }

        {
          showExtraText && <span style={{
            fontSize: '13px',
            position: 'absolute',
            right: '5px',
            bottom: '5px',
            background: '#F9F9FB',
            paddingLeft: '16px',
          }}>{extraText}</span>
        }

        {
          (name === "finance_status" || name === "operation_status") && showIcon && (
            <span
              onClick={emailReminderLoading ? null : value === "rejected" ? null : value === "approved" ? null : () => emailReminderHandler(name)}
              style={{
                position: 'absolute',
                right: '15px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: emailReminderLoading ? 'not-allowed' : value === "rejected" ? 'not-allowed' : value === "approved" ? 'not-allowed' : 'pointer',
                color: '#666'
              }}
            >
              {showIcon}
            </span>
          )
        }

        {type === 'password' && (
          <span
            onClick={togglePasswordVisibility}
            style={{
              position: 'absolute',
              right: '15px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        )}
      </div>
      {touched && error && <div className="error-message" style={{ color: '#ff0000de', fontSize: '12px', marginTop: "3px", marginLeft: "5px" }}>{error}</div>}
    </div>
  )
}

export default Input